import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/img/icon.jpeg'


const _hoisted_1 = { class: "w-full font-montserrat relative" }
const _hoisted_2 = {
  key: 0,
  class: "bg-red-500 left-[50%] translate-x-[-50%] border border-red-500 text-white text-center font-bold flex justify-center items-center fixed top-[70px] z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_3 = { class: "relative mb-[50px] w-full" }
const _hoisted_4 = { class: "py-[20px] flex flex-col items-center relative bg-gray-50 min-h-screen top-[60px]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-black font-bold py-[20px] text-center" }, "Home / Profil", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl uppercase font-bold text-center text-black py-[20px]" }, "Profile", -1)
const _hoisted_7 = { class: "block md:flex justify-center w-[90%] py-[10px]" }
const _hoisted_8 = { class: "md:w-[200px] p-[10px] w-full md:h-[200px] bg-white md:mx-[10px] flex flex-col justify-center items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-[120px] h-[120px] rounded-[50%] border border-black"
}, null, -1)
const _hoisted_10 = { class: "uppercase my-[10px]" }
const _hoisted_11 = { class: "w-full md:my-[0px] my-[20px] md:w-[calc(100%-240px)] relative bg-white md:mx-[10px] px-[10px] py-[50px]" }
const _hoisted_12 = { class: "md:py-[40px] md:px-[20px] px-[10px] py-[30px]" }
const _hoisted_13 = ["onSubmit"]
const _hoisted_14 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "First Name", -1)
const _hoisted_16 = { class: "relative min-w-[50%] max-w-[55%]" }
const _hoisted_17 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "Last Name", -1)
const _hoisted_19 = { class: "relative min-w-[50%] max-w-[55%]" }
const _hoisted_20 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "About", -1)
const _hoisted_22 = { class: "relative min-w-[50%] max-w-[55%]" }
const _hoisted_23 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "Job", -1)
const _hoisted_25 = { class: "relative min-w-[50%] max-w-[55%]" }
const _hoisted_26 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "Phone", -1)
const _hoisted_28 = { class: "relative min-w-[50%] max-w-[55%]" }
const _hoisted_29 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "Email", -1)
const _hoisted_31 = { class: "relative min-w-[50%] max-w-[55%]" }
const _hoisted_32 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "Linkedin Profile", -1)
const _hoisted_34 = { class: "relative min-w-[50%] max-w-[55%]" }
const _hoisted_35 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "Twitter Profile", -1)
const _hoisted_37 = { class: "relative min-w-[50%] max-w-[55%]" }
const _hoisted_38 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "Instagram Profile", -1)
const _hoisted_40 = { class: "relative min-w-[50%] max-w-[55%]" }
const _hoisted_41 = { class: "flex py-[15px] items-center justify-between" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "text-cyan-600" }, "Facebook Profile", -1)
const _hoisted_43 = { class: "relative min-w-[50%] max-w-[55%]" }
const _hoisted_44 = { class: "flex py-[15px] items-center justify-center" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_47 = { key: 1 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-400 py-[50px] flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import headerComponent from '../components/headerComponentAdmin.vue'
import linkProfile from '../components/linkProfile.vue' 
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import axiosInstance from '@/plugins/axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileEdit',
  setup(__props) {

const pageTitle = ref('Profile Edit');
const router = useRouter();
    
const loading = ref(false);



onMounted(() => {
    document.title = pageTitle.value; 
});
const updatedUser = ref({});
const errorMessage = ref('');

const fetchUserProfile = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    const response = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    updatedUser.value = { ...response.data }; 
  } catch (error) {
    console.error(error);
  }
};

onMounted(() => {
  fetchUserProfile();
});

const updateUserProfile = async () => {
  try {
    loading.value = true;
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }
    await axiosInstance.put('/auth/users/me/', updatedUser.value, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    errorMessage.value = '';

    router.push('/Profile');
  } catch (error: any) {
    console.error(error);
    if (error.response && error.response.data && error.response.data.message) {
          errorMessage.value = error.response.data.message;
    } else {
          errorMessage.value = 'Une erreur s\'est produite lors de la mise à jour.';
    }
    
  } finally {
        loading.value = false; 
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(headerComponent),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("h1", _hoisted_10, _toDisplayString(updatedUser.value.firstname) + " " + _toDisplayString(updatedUser.value.lastname), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(linkProfile),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(updateUserProfile, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((updatedUser.value.firstname) = $event)),
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full",
                      placeholder: "Ex: Nassym"
                    }, null, 512), [
                      [_vModelText, updatedUser.value.firstname]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updatedUser.value.lastname) = $event)),
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full",
                      placeholder: "Ex: ALASSANE"
                    }, null, 512), [
                      [_vModelText, updatedUser.value.lastname]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((updatedUser.value.about) = $event)),
                      class: "border h-[100px] border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full",
                      placeholder: "Passionné par l'it Passionné par l'it Passionné par l'it"
                    }, " ", 512), [
                      [_vModelText, updatedUser.value.about]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((updatedUser.value.job) = $event)),
                      type: "text",
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full",
                      placeholder: "Analyst cybersécurité"
                    }, null, 512), [
                      [_vModelText, updatedUser.value.job]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((updatedUser.value.phone) = $event)),
                      type: "text",
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full",
                      placeholder: "Ex: 66656422"
                    }, null, 512), [
                      [_vModelText, updatedUser.value.phone]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((updatedUser.value.email) = $event)),
                      type: "text",
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full",
                      placeholder: "Ex: ironsecur@gmail.com"
                    }, null, 512), [
                      [_vModelText, updatedUser.value.email]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((updatedUser.value.linkedIn) = $event)),
                      type: "text",
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full",
                      placeholder: "https://www.linkedin.com/#"
                    }, null, 512), [
                      [_vModelText, updatedUser.value.linkedIn]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((updatedUser.value.twitter) = $event)),
                      type: "text",
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full",
                      placeholder: "https://www.twitter.com/#"
                    }, null, 512), [
                      [_vModelText, updatedUser.value.twitter]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((updatedUser.value.instagram) = $event)),
                      type: "text",
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full",
                      placeholder: "https://www.instagram.com/#"
                    }, null, 512), [
                      [_vModelText, updatedUser.value.instagram]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((updatedUser.value.facebook) = $event)),
                      type: "text",
                      class: "border border-gray-800 focus:border-cyan-500 text-black outline-none rounded-[5px] py-[5px] px-[10px] w-full",
                      placeholder: "https://www.facebook.com/#"
                    }, null, 512), [
                      [_vModelText, updatedUser.value.facebook]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: loading.value,
                    class: "uppercase cursor-pointer font-bold bg-cyan-500 text-white outline-none rounded-[5px] py-[5px] px-[30px] w-auto"
                  }, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_46))
                      : (_openBlock(), _createElementBlock("span", _hoisted_47, "Save"))
                  ], 8, _hoisted_45)
                ])
              ], 40, _hoisted_13)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_48
  ]))
}
}

})